import type { UserRoleRemoveButtonProps } from "./user-role-remove-button.type";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useRemoveRole } from "@/hooks/queries/user";
import { useAuthorization } from "@/modules/authorization";

export const UserRoleRemoveButton = ({
  role,
  userId,
}: UserRoleRemoveButtonProps) => {
  const { t } = useTranslation();
  const mutation = useRemoveRole("users", userId);
  const { canManageRole } = useAuthorization();

  const removePermission = () => {
    mutation.mutate({
      behavior: role.behavior,
      subject_id: role.subject_id || null,
    });
  };

  return (
    <Button
      onClick={removePermission}
      disabled={!canManageRole(role.subject)}
      loading={mutation.isPending}
    >
      {t("user:removePermission")}
    </Button>
  );
};
